import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Textarea,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { PropertyAddressCard } from '../../../property/components/property-address-card';
import { ResolveIssueFormValues } from './form-schema';

function ResolveIssueFormBody({
    propertyId,
    onClose,
    onSubmit,
}: {
    propertyId: number;
    onClose: () => void;
    onSubmit: (vals: ResolveIssueFormValues) => void;
}) {
    const form = useFormContext<ResolveIssueFormValues>();

    return (
        <>
            <ModalHeader>Request resolve access issue</ModalHeader>

            <ModalBody>
                <PropertyAddressCard w="full" mb={5} propertyId={propertyId} />

                {/* loading data */}
                <Box w="full">
                    <Controller
                        name="resolveReason"
                        control={form.control}
                        render={({ field, fieldState }) => (
                            <FormControl isRequired isInvalid={fieldState.invalid}>
                                <FormLabel>Notes of action taken</FormLabel>
                                <Textarea {...field} isInvalid={fieldState.invalid} />

                                {fieldState.error && (
                                    <FormErrorMessage>{fieldState.error.message}</FormErrorMessage>
                                )}
                            </FormControl>
                        )}
                    />
                </Box>
            </ModalBody>

            <ModalFooter justifyContent="space-between">
                <Button colorScheme="muted" variant="ghost" onClick={onClose}>
                    Close
                </Button>

                <Button onClick={form.handleSubmit(onSubmit)} colorScheme="secondary">
                    Next
                </Button>
            </ModalFooter>
        </>
    );
}

export { ResolveIssueFormBody };
